import { DEFAULT_RUNTIME_CONFIG, type RuntimeConfig } from '@/domain/runtime'
import type { RuntimeConfigApi } from '@/ports/runtime-config-api'

/**
 * HttpRuntimeConfigApi : adapter GET /api/v1/runtime-config (control-plane).
 *
 * Si l'endpoint répond 401 / 403 / 404 ou un body invalide, on retombe sur
 * DEFAULT_RUNTIME_CONFIG (dataPlaneUrl vide → l'UI utilisera
 * window.location.origin). Le runtime config est de l'info de confort, son
 * absence ne doit pas bloquer le boot SPA.
 */
export class HttpRuntimeConfigApi implements RuntimeConfigApi {
    private readonly baseURL: string

    constructor(baseURL = '') {
        this.baseURL = baseURL.replace(/\/+$/, '')
    }

    async get(): Promise<RuntimeConfig> {
        let resp: Response
        try {
            resp = await fetch(this.baseURL + '/api/v1/runtime-config', {
                method: 'GET',
                credentials: 'include',
                cache: 'no-store',
            })
        } catch {
            return DEFAULT_RUNTIME_CONFIG
        }
        if (!resp.ok) {
            return DEFAULT_RUNTIME_CONFIG
        }
        let body: unknown
        try {
            body = await resp.json()
        } catch {
            return DEFAULT_RUNTIME_CONFIG
        }
        if (!body || typeof body !== 'object') {
            return DEFAULT_RUNTIME_CONFIG
        }
        const obj = body as Record<string, unknown>
        const dataPlaneUrl = typeof obj.data_plane_url === 'string' ? obj.data_plane_url : ''
        return { dataPlaneUrl }
    }
}
